import React from 'react';
import AppCollect from './AppCollect';
import Collect from './Collect';

class App extends React.Component {

  render() {
    const id = this.props.location.query.id;
    if (id !== 'workflow') return (<AppCollect {...this.props} />);
    return (<Collect {...this.props} />);
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/collect/index.js